		var showChar = 200;
		var ellipsestext = "...";
		var moretext = "Read More";
		var lesstext = "Read Less";

		if($('.hidden_footer.is_home').length){
			var content = $('.hidden_footer.is_home').html().split(/\s+/).join(' ');
			if(content.length > showChar) {
				var c = content.substr(0, showChar);
				var h = content.substr(showChar, content.length - showChar);

				var html = c + '<span class="moreelipses">'+ellipsestext+'</span><span class="morecontent"><span>' + h + '</span><div class="morelink">'+moretext+'</div></span>';

				$('.hidden_footer.is_home').html(html);
			}
		}

		$(".morelink").click(function(){
			if($(this).hasClass("less")) {
				$(this).removeClass("less").html(moretext);
			} else {
				$(this).addClass("less").html(lesstext);
			}
			$(this).parent().prev().slideToggle('fast').css('display','initial');
			$(this).prev().slideToggle('fast').css('display','initial');
			return false;
		});

		$("#footer_readmore").click(function(){
			if($(this).hasClass("less")) {
				$(this).removeClass("less").html(moretext);
			} else {
				$(this).addClass("less").html(lesstext);
			}
			$(".hidden_footer").toggle().toggleClass('hide');
		});
		

		$('.footer-support-desktop-support-custm').on('click', '.tab', function(event) {
			event.preventDefault();
		
			var val = $(this).find('a').attr('val');
			
			$('.footer-support-desktop-support-custm').find('.tab-pane').not(val).hide();
			$(val).show(); 
			
			$('.footer-support-desktop-support-custm').find('.tab').removeClass('collapsed');
			$('.footer-support-desktop-support-custm').find('.tab-pane').removeClass('flexed');
			
			$(this).addClass('collapsed');
			$(val).addClass('flexed');
		});
		

	    $('#footer-support-mobile').on('click','.tab', function(event) {
		  event.preventDefault();
	      var val = $(this).find('a').attr('val');
	      $('.footer-support-mobile').find('.pane-container:not('+ val +')').hide();
	      var inactiveTab = $('.footer-support-mobile').find('a:not([val='+ val +'])').parents('.tab');
	      $(this).toggleClass('collapsed');
	      $(val).toggle();
	      if(inactiveTab.hasClass('collapsed')){
	        inactiveTab.removeClass('collapsed');
	        $('.footer-support-mobile').find('.pane-container:not('+ val +')').hide();
	      }

	    }); 

		$(".close-qr").click(function() {
            $(".download-app-qr").hide();
        });

		const scrollAmount = 110; 

			$('.right-arrow').on('click', function() {
				$('.footer-tabs').animate({
					scrollLeft: '+=' + scrollAmount
				}, 300);
			});

			$('.left-arrow').on('click', function() {
				$('.footer-tabs').animate({
					scrollLeft: '-=' + scrollAmount
				}, 300);
			});

			var liCountipo = $('.flex-footer-secton-4 .widget-products .menu li').length;		
			var liCountser = $('.flex-footer-secton-4 .widget-company .menu li').length;	
			var liCountcom = $('.flex-footer-secton-4 .widget-upstox .menu li').length;	
			
			if (liCountipo > 6) {
				$('#menu-footer-products').addClass('more_six_list');
			}

			if (liCountser > 6) {
				$('#menu-footer-service-pages').addClass('more_six_list');
			}

			if (liCountcom > 6) {
				$('#menu-footer-company').addClass('more_six_list');
			}
 
			

			$(".investors-footer").click(function(){
				$("#tnc").toggle();
				$(".flex-footer-secton-5").toggleClass('add-arrow-foot');
			  });

			$(".flex-footer-secton-4.desktop-show .widget__title").click(function(){
				$(".widget_nav_menu").toggleClass('section4-arrows');
				$(".desktop-show").show();
			  
			});

			$(".flex-footer-secton-4.mobile-show .widget-products").click(function(){
				$(".widget-products").toggleClass('section4-arrows');
				$(".mobile-show").show();
			  
			});
			$(".flex-footer-secton-4.mobile-show .widget-company").click(function(){
				$(".widget-company").toggleClass('section4-arrows');
				$(".mobile-show").show();
			  
			});
			$(".flex-footer-secton-4.mobile-show .widget-upstox").click(function(){
				$(".widget-upstox").toggleClass('section4-arrows');
				$(".mobile-show").show();
			  
			});	

			$(window).scroll(function () {
				if ($(window).width() < 768) { 
					if ($(this).scrollTop() > 100) {
						$(".pt-90.download-tranding-sec.new-sticky-wrap-set").fadeIn();
					} else {
						$(".pt-90.download-tranding-sec.new-sticky-wrap-set").fadeOut();
					}
				}
			});
			  